<template>
  <section>
    <top-menu/>
    <modal-update-solicitation :value-modal="updateStatus" :title-modal="modalTitle"
                               :type-modal="modalType" :run-function="getContentBenefitsCardsChange"/>
    <!-- Loading from page -->
    <full-loading v-if="loadingBenefitsCards"/>

    <section v-else>
      <div class="page-content">
        <div class="container-fluid">
          <div class="col-xs-12 col-sm-12 col-md-12 table-box">
            <div class="table-box--header">
              <span class="table-box--header-title">
                <ion-icon name="receipt-outline"></ion-icon>
                Solicitações de cartão
              </span>
              <span class="table-box--header-subtitle">
                Gerencie as solicitações de cartões efetuados pelas empresas
              </span>
              <div class="row">
                <div class="table-box--form">
                  <div class="form-text-1 col-md-4">
                    <label>Id da empresa</label>
                    <div class="form-text-1-input">
                      <input v-model="filterRequest.idValue" type="text" placeholder="Digite um id"
                             autocomplete="off">
                      <ion-icon name="search-outline"></ion-icon>
                    </div>
                  </div>
                  <div class="form-text-2 col-md-4">
                    <label>Nome da empresa</label>
                    <div class="form-text-2-input">
                      <input v-model="filterRequest.nameValue" type="text" placeholder="Digite um nome"
                             autocomplete="off">
                      <ion-icon name="search-outline"></ion-icon>
                    </div>
                  </div>
                  <div class="form-select col-md-2">
                    <label>Status</label>
                    <div class="form-select-input">
                      <select v-model="filterRequest.statusValue">
                        <option value="" selected>Selecione</option>
                        <option value="0">Não definido</option>
                        <option value="1">Pendente</option>
                        <option value="2">Em Progresso</option>
                        <option value="3">Entregue</option>
                        <option value="4">Cancelado</option>
                      </select>
                      <ion-icon name="chevron-down-outline"></ion-icon>
                    </div>
                  </div>
                  <div class="form-button col-md-2">
                    <button @click="getContentBenefitsCards()">Filtrar</button>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="contentBenefitsCards.length !== 0"
                 class="table-box--content">
              <table class="content-table">
                <thead>
                <tr>
                  <th>
                    ID
                    <ion-icon id="orderId" v-on:click="orderSort('orderId')"
                              name="caret-down-outline"></ion-icon>
                  </th>
                  <th>
                    Empresa
                    <ion-icon id="company" v-on:click="orderSort('company')"
                              name="caret-down-outline"></ion-icon>
                  </th>
                  <th>
                    Cartões
                    <ion-icon id="cards" v-on:click="orderSort('cards')"
                              name="caret-down-outline"></ion-icon>
                  </th>
                  <th>
                    Unidade de Negócio
                    <ion-icon id="businessUnit" v-on:click="orderSort('businessUnit')"
                              name="caret-down-outline"></ion-icon>
                  </th>
                  <th>
                    Status
                    <ion-icon id="status" v-on:click="orderSort('status')"
                              name="caret-down-outline"></ion-icon>
                  </th>
                  <th>
                    Criado em
                    <ion-icon id="createdAt" v-on:click="orderSort('createdAt')"
                              name="caret-down-outline"></ion-icon>
                  </th>
                  <th>Ações</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(value, index) in contentBenefitsCards" :key="index">
                  <td class="content-table--company-name" :title="value.id">
                    {{ value.id }}
                  </td>
                  <td class="content-table-name">
                    <div>
                      <router-link :to="{path: '/detalhes-da-empresa/' + value.companyId + '/' + value.contextCode}"
                                   target="_blank">{{ value.name }}
                      </router-link>
                      <span>{{ value.companyId }}</span>
                    </div>
                  </td>
                  <td class="content-table-cards">
                    <div>
                      <span class="cards-by">
                        {{ value.cards }}
                        <span v-if="value.duplicated"> (2ª via)</span>
                        <span v-else> (1ª via)</span>
                      </span>
                      <span class="cards-by" v-if="value.drawer !== 0">
                        {{ value.drawer }}<span>(gaveta)</span>
                      </span>
                    </div>
                  </td>
                  <td class="content-business-unit">
                    <div>
                      {{ value.businessUnitName }}
                      <span>{{ value.businessUnitDocument }}</span>
                    </div>
                  </td>
                  <td class="content-table--status">
                    <span v-if="value.status === 0" class="none">
                      Não definido
                    </span> <span v-if="value.status === 1" class="pending">
                      Pendente
                    </span> <span v-if="value.status === 2" class="in-progress">
                      Em progresso
                    </span> <span v-if="value.status === 3" class="concluded">
                      Entregue
                    </span> <span v-if="value.status === 4" class="canceled">
                      Cancelado
                    </span>
                  </td>
                  <td class="content-table--created">
                    {{ value.createdAt | formatDate }}
                  </td>
                  <td class="content-table--actions">
                    <div class="buttons-actions">
                      <router-link :to="{path: '/detalhes-solicitacao/' + value.id}"
                                   target="_blank"
                                   class="view-card">
                        Visualizar
                      </router-link>
                      <span class="update-status" @click="openModalSolicitation(value.id, 1, 'Atualizar solicitação')">Atualizar status</span>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import modalUpdateSolicitation from "../../modals/modalUpdateSolicitation";
import fullLoading from "../../components/default/fullLoading.vue";
import {REQUEST_SERVICE, UTIL_SERVICE} from "../../../../requestConfig";
import {CARD_DETAILS, CARDS_BENEFITS, GET_UNIT_MASTER} from "../../../../urlConfig";
import swal from "sweetalert";

export default {
  name: "benefits-card-requests",
  components: {
    topMenu,
    fullLoading,
    modalUpdateSolicitation,
  },
  data() {
    return {
      loadingBenefitsCards: false,
      contentBenefitsCards: '',
      sortNameGrow: false,
      sortStatusGrow: false,
      filterRequest: {
        statusValue: '',
        nameValue: '',
        orderValue: '',
        idValue: '',
      },
      modalTitle: '',
      modalType: '',
      updateStatus: {
        solicitationData: {
          id: '',
          businessUnit: '',
          plan: '',
          planValue: '',
          benefitsValue: '',
          changeFrom: '',
          notes: '',
          status: '',
        },
        requesterData: {
          name: '',
          phone: '',
          email: '',
        },
        addressData: {
          city: '',
          country: '',
          number: '',
          street: '',
          state: '',
          zipCode: ''
        },
        shippingData: {
          trackCode: '',
          deliveryOptions: '',
        },
        businessUnitChange: '',
      },
    };
  },
  methods: {
    getContentBenefitsCards() {
      this.loadingBenefitsCards = true;

      let url = CARDS_BENEFITS + "?p=1";

      if (this.filterRequest.idValue) {
        url += '&companyId=' + this.filterRequest.idValue
      }
      if (this.filterRequest.orderValue) {
        url += '&orderId=' + this.filterRequest.orderValue
      }
      if (this.filterRequest.statusValue || this.filterRequest.statusValue === 0) {
        url += '&status=' + this.filterRequest.statusValue
      }

      REQUEST_SERVICE.get(url)
        .then((response) => {
          UTIL_SERVICE.console("RESULT CARDS_BENEFITS:", response.data);

          this.contentBenefitsCards = response.data;
          this.loadingBenefitsCards = false;
        })
        .catch((reason) => {
          this.loadingBenefitsCards = false;
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    getContentBenefitsCardsChange() {
      let url = CARDS_BENEFITS + "?p=1";

      if (this.filterRequest.idValue) {
        url += '&companyId=' + this.filterRequest.idValue
      }
      if (this.filterRequest.orderValue) {
        url += '&orderId=' + this.filterRequest.orderValue
      }
      if (this.filterRequest.statusValue || this.filterRequest.statusValue === 0) {
        url += '&status=' + this.filterRequest.statusValue
      }

      REQUEST_SERVICE.get(url)
        .then((response) => {
          UTIL_SERVICE.console("RESULT CARDS_BENEFITS:", response.data);

          this.contentBenefitsCards = response.data;
        })
        .catch((reason) => {
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    orderSort(value) {
      $('#orderId').css('transform', 'rotate(0deg)');
      $('#company').css('transform', 'rotate(0deg)');
      $('#cards').css('transform', 'rotate(0deg)');
      $('#businessUnit').css('transform', 'rotate(0deg)');
      $('#status').css('transform', 'rotate(0deg)');
      $('#createdAt').css('transform', 'rotate(0deg)');

      this.contentBenefitsCards = this.contentBenefitsCards.sort(function (a, b) {
        let valueA = a[value];
        let valueB = b[value];
        if (typeof valueA === 'string') {
          valueA = valueA.toLowerCase().trim();
        }

        if (typeof valueB === 'string') {
          valueB = valueB.toLowerCase().trim();
        }

        if (valueA > valueB) {
          return 1;
        }
        if (valueA < valueB) {
          return -1;
        }
        return 0;
      });

      if (this[value + 'Order'] === true) {
        this.contentBenefitsCards.reverse();
        $('#' + value).css('transform', 'rotate(0deg)');
      } else {
        $('#' + value).css('transform', 'rotate(180deg)');
      }

      this[value + 'Order'] = !this[value + 'Order']
    },
    setBusinessUnit(value, type, title) {
      REQUEST_SERVICE.get(GET_UNIT_MASTER + '?i=' + value.companyId)
        .then((response) => {
          UTIL_SERVICE.console("RESULT GET_UNIT_MASTER:", response.data);

          this.modalTitle = title;
          this.modalType = type;

          this.updateStatus = {
            solicitationData: {
              id: value.id,
              businessUnit: value.businessUnitName,
              plan: value.subscription.plan,
              planValue: value.subscription.totalCost,
              benefitsValue: value.subscription.benefitsPrice,
              changeFrom: value.subscription.chargeNotes,
              notes: value.notes,
              status: value.status,
              businessUnitId: value.businessUnitId,
            },
            requesterData: {
              name: value.contactName,
              phone: value.contactPhone,
              email: value.contactEmail,
            },
            addressData: {
              city: value.address.city,
              country: value.address.country,
              number: value.address.number,
              street: value.address.street,
              state: value.address.state,
              zipCode: value.address.zipCode,
            },
            shippingData: {
              trackCode: value.trackCode,
              deliveryOptions: value.deliveryOptions,
            },
            additionalData: {
              companyId: value.companyId,
              drawerCards: value.drawer,
              qtdUsers: value.users.length,
              contextCode: value.contextCode,
              neighborhood: value.address.neighborhood,
              complement: value.address.complement,
              longitude: value.address.longitude,
              latitude: value.address.latitude,
              createdAt: value.createdAt,
              cardOrderId: value.id,
            },
            businessUnitChange: response.data
          };

          $("#update-solicitation").modal();
        })
        .catch((reason) => {
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    openModalSolicitation(solicitationId, type, title) {
      REQUEST_SERVICE.get(CARD_DETAILS + '/' + solicitationId)
        .then((response) => {
          UTIL_SERVICE.console("RESULT CARD_DETAILS:", response.data);

          this.setBusinessUnit(response.data, type, title)
        })
        .catch((reason) => {
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    }
  },
  beforeMount() {
    this.statusValue = this.$route.params.statusId
    this.getContentBenefitsCards();
  },
}
</script>.

<style lang="scss" scoped>
.container-fluid {
  .table-box {
    padding: 30px;
    background: var(--classic-white);
    border-radius: 10px !important;

    .table-box--header {
      .table-box--header-title {
        display: flex;
        align-items: center;

        font-size: 24px;
        font-weight: 700;
        color: var(--classic-black);

        ion-icon {
          margin-right: 10px;
          font-size: 22px;
          color: var(--dark-gray);
        }
      }

      .table-box--header-subtitle {
        font-size: 16px;
        font-weight: 400;
        color: var(--dark-gray);
      }

      .row {
        margin: 0;
      }

      .table-box--form {
        display: flex;
        margin-top: 25px;

        .form-text-1 {
          display: flex;
          flex-direction: column;
          padding: 0;
          margin-right: 15px;

          label {
            font-size: 14px;
            font-weight: 400;
            color: var(--border-gray);
          }

          .form-text-1-input {
            display: flex;
            position: relative;

            ion-icon {
              position: absolute;
              right: 10px;
              top: 10px;
              font-size: 16px;
              color: var(--dark-gray);
            }

            input {
              width: 100%;
              background: #EEF2F7;
              border-radius: 4px !important;
              padding: 6px 12px;
              border: 1px solid #EEF2F7;
              transition: .2s;

              font-size: 16px;
              font-weight: 400;
              color: var(--dark-gray);

              &::placeholder {
                font-size: 16px;
                font-weight: 400;
                color: var(--dark-gray);
              }

              &:hover {
                transition: .2s;
                border: 1px solid #cacaca;
              }

              &:focus-visible {
                outline: none;
                transition: .2s;
                border: 1px solid #cacaca;

                &::placeholder {
                  transition: .1s;
                  color: #EEF2F7;
                }
              }
            }
          }
        }

        .form-text-2 {
          display: flex;
          flex-direction: column;
          padding: 0;
          margin-right: 15px;
          margin-left: 15px;

          label {
            font-size: 14px;
            font-weight: 400;
            color: var(--border-gray);
          }

          .form-text-2-input {
            display: flex;
            position: relative;

            ion-icon {
              position: absolute;
              right: 10px;
              top: 10px;
              font-size: 16px;
              color: var(--dark-gray);
            }

            input {
              width: 100%;
              background: #EEF2F7;
              border-radius: 4px !important;
              padding: 6px 12px;
              border: 1px solid #EEF2F7;
              transition: .2s;

              font-size: 16px;
              font-weight: 400;
              color: var(--dark-gray);

              &::placeholder {
                font-size: 16px;
                font-weight: 400;
                color: var(--dark-gray);
              }

              &:hover {
                transition: .2s;
                border: 1px solid #cacaca;
              }

              &:focus-visible {
                outline: none;
                transition: .2s;
                border: 1px solid #cacaca;

                &::placeholder {
                  transition: .1s;
                  color: #EEF2F7;
                }
              }
            }
          }
        }

        .form-select {
          display: flex;
          flex-direction: column;
          padding: 0;
          margin-right: 15px;
          margin-left: 15px;

          label {
            font-size: 14px;
            font-weight: 400;
            color: var(--border-gray);
          }

          .form-select-input {
            position: relative;

            ion-icon {
              position: absolute;
              right: 10px;
              top: 11px;
              font-size: 16px;
              color: var(--dark-gray);
              cursor: pointer;
              pointer-events: none;


            }

            select {
              width: 100%;
              background: #EEF2F7;
              border-radius: 4px !important;
              padding: 6px 12px;
              border: 1px solid #EEF2F7;
              transition: .2s;
              font-size: 16px;
              font-weight: 400;
              color: var(--dark-gray);
              cursor: pointer;

              -webkit-appearance: none;
              -moz-appearance: none;
              appearance: none;

              &::placeholder {
                font-size: 16px;
                font-weight: 400;
                color: var(--dark-gray);
              }

              &:hover {
                transition: .2s;
                border: 1px solid #cacaca;
              }

              &:focus-visible {
                outline: none;
                transition: .2s;
                border: 1px solid #cacaca;

                &::placeholder {
                  transition: .1s;
                  color: #EEF2F7;
                }
              }
            }
          }
        }

        .form-button {
          padding-right: 0;

          button {
            width: 100%;
            height: 59%;
            margin-top: 25.5px;
            background: #2F23D6;
            color: #ffffff;
            border-radius: 4px !important;
            border: none;

            &:hover {
              background: #20179e;
            }
          }
        }
      }
    }

    .table-box--content {
      margin-top: 50px;

      .content-table {
        width: 99%;
        max-width: 99%;
        margin-bottom: 20px;

        thead {
          font-size: 14px;
          color: var(--high-gray);
          line-height: 220%;
          padding-bottom: 5px;
          border-bottom: 1px solid var(--classic-gray);

          tr {
            th {
              font-weight: 500 !important;

              ion-icon {
                width: 13px;
                height: 13px;
                transition: .3s;
                cursor: pointer;
              }
            }
          }
        }

        tbody {
          tr {
            border-bottom: 1px solid var(--classic-gray);

            .content-table--company-name {
              color: #3A424E;
              padding: 20px 0;

              display: list-item;
              width: 80px;
              white-space: nowrap;
              overflow: hidden !important;
              text-overflow: ellipsis;

              font-size: 14px;
              font-weight: 400;
              align-items: center;
            }

            .content-table-name {
              div {
                display: flex;
                flex-direction: column;

                a {
                  font-size: 14px;
                  text-decoration: none;
                  color: #2F23D6;
                }

                span {
                  font-size: 11px;
                  color: #7F8897;
                }
              }
            }

            .content-table-cards {
              div {
                display: flex;
                flex-direction: column;

                .cards-by {
                  font-size: 14px;
                  font-weight: 400;
                  color: #3a424E;
                  line-height: 19.69px;

                  span {
                    color: #7F8897;
                  }
                }
              }
            }

            .content-business-unit {
              div {
                display: flex;
                flex-direction: column;
                font-size: 14px;
                font-weight: 400;
                color: #3A424E;
                line-height: 19.69px;

                span {
                  font-size: 11px;
                  color: #7F8897;
                }
              }
            }

            .content-table--status {
              span {
                border-radius: 4px !important;
                font-size: 12px;
                font-weight: 500;
                padding: 4px 16px;
              }

              .done {
                color: var(--classic-white);
                background: var(--dark-gray);
                padding: 4px 16px;
              }

              .draw {
                color: var(--dark-gray);
                background: var(--drop-shadow-blue);
                padding: 4px 24px;
              }

              .waiting {
                color: var(--dark-gray);
                background: var(--light-yellow);
                padding: 4px 16px;
              }

              .paid {
                background: var(--light-green);
                color: var(--classic-white);
                padding: 4px 38.5px;
              }

              .canceled {
                background: var(--classic-gray);
                color: var(--border-gray);
                padding: 4px 23.5px;
              }

              .pending {
                color: var(--dark-gray);
                background: var(--light-yellow);
                padding: 4px 26px;
              }

              .in-progress {
                color: var(--classic-white);
                background: var(--high-blue);
                padding: 4px 13.5px;
              }

              .concluded {
                background: var(--light-green);
                color: var(--classic-white);
                padding: 4px 25px;
              }

              .none {
                background: var(--dark-gray);
                color: var(--classic-white);
                padding: 4px 28.7px;
              }
            }

            .content-table--value {
              font-size: 16px;
              font-weight: 400;
              color: var(--dark-gray);
            }

            .content-table--created {
              display: flex;
              flex-direction: column;
              margin-top: 11px;

              font-size: 14px;
              font-weight: 400;
              color: var(--dark-gray);

              span {
                font-size: 12px;
                font-weight: 400;
                color: var(--high-gray);
              }
            }

            .content-table--actions {
              .buttons-actions {
                display: flex;
                flex-direction: row;

                .view-card {
                  border: 1px solid #2F23D6;
                  border-radius: 30px !important;
                  padding: 5px 16px;
                  color: #2F23D6;
                  font-size: 12px;
                  font-weight: 400;
                  cursor: pointer;
                  transition: .2s;
                  margin-right: 10px;
                  text-decoration: none;

                  &:hover {
                    color: #FFFFFF;
                    background: #2F23D6;
                  }
                }

                .update-status {
                  border: 1px solid #2F23D6;
                  border-radius: 30px !important;
                  padding: 5px 16px;
                  color: #2F23D6;
                  font-size: 12px;
                  font-weight: 400;
                  cursor: pointer;
                  transition: .2s;

                  &:hover {
                    color: #FFFFFF;
                    background: #2F23D6;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/benefits/benefits-card-request.vue